import { Link, useNavigate } from "react-router-dom";
import styles from "../signin/styles/style.module.css";
import { useState } from "react";
import apiEndPoint from "../../services/apiService/apiEndPoints";
import { postApi } from "../../services/apiService/fetchMethod";
import tostMessage from "../../utils/tostMessage";
import SiginAndSignUpWrapper from "../../components/SigninAndSignup/SiginAndSignUpWrapper";
import InputField from "../../commonComponents/InputField/InputField";
import Loader from "../../commonComponents/loader/Loader";
function Signup() {
  const navigate = useNavigate();
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [userData, setUserData] = useState([]);
  const [loading, setLoading] = useState(false);
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    // Trim white spaces from the input values
    const trimmedFirstName = firstName.trim();
    const trimmedLastName = lastName.trim();
    const trimmedEmail = email.trim();
    const trimmedPhone = phone.trim();
    const trimmedPassword = password.trim();
    let url = apiEndPoint().SIGNUP;
    let params = {
      email:trimmedEmail,
      password:trimmedPassword,
      firstName:trimmedFirstName,
      lastName:trimmedLastName,
      phone:trimmedPhone,
    };
    const { status, data } = await postApi({ url, params });
    console.log(data);
    tostMessage(status, data?.message);
    if (status === 200) {
      navigate("/signin");
    }
    setLoading(false);
  };

  return (
    <SiginAndSignUpWrapper
      title="Signup"
      setUserData={setUserData}
    >
      <form onSubmit={handleSubmit}>
        <div className={styles.formBox}>
          <InputField
            placeholder="First Name"
            type="text"
            required={true}
            seterVal={setFirstName}
            gaterVal={firstName}
          />
        </div>
        <div className={styles.formBox}>
          <InputField
            placeholder="Last Name"
            type="text"
            required={true}
            seterVal={setLastName}
            gaterVal={lastName}
          />
        </div>
        <div className={styles.formBox}>
          <InputField
            placeholder="Email"
            type="text"
            required={true}
            seterVal={setEmail}
            gaterVal={email}
          />
        </div>
        <div className={styles.formBox}>
          <InputField
            placeholder="Phone Number"
            type="text"
            required={true}
            seterVal={setPhone}
            gaterVal={phone}
          />
        </div>
        <div className={styles.formBox} style={{ marginBottom: "0.5rem" }}>
          <InputField
            placeholder="Password"
            type="password"
            required={true}
            seterVal={setPassword}
            gaterVal={password}
          />
        </div>

        <button
          className={styles.loginBtn}
          style={{
            width: "100%",
            padding: loading ? "0.28rem" : "1rem",
            marginTop: "10px",
          }}
          type="submit"
        >
          {loading ? <Loader /> : "Create Account"}
        </button>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginTop: "1rem",
          }}
        >
          <Link
            to="/signin"
            className={styles.forgetText}
            style={{ fontSize: "14px", fontWeight: "500" }}
          >
            Already have an account? Login
          </Link>
        </div>
      </form>
    </SiginAndSignUpWrapper>
  );
}

export default Signup;
